import { useMutationState } from "@tanstack/react-query";

import numbers from "core/numbers";
import useNav from "core/hooks/useNav";

import { useMutateLogin, useMutateLogout, useMutateSecondary, useMutateSignup, useMutateValidate, useQueryDevice } from "features/auth/data";
import { useStoreAuth } from "features/auth/store";
import { useStart } from "features/start/fabric";


export const useDevice = () => {
	const { data } = useQueryDevice();
	return data;
};

export const useAuth = () => {
	const auth = useStoreAuth();
	const account = auth.isEmail() ? auth.email : numbers.toPhone(auth.phone);


	return { ...auth, account };
};

export const useAuthValidate = () => {
	const auth = useStoreAuth();
	const start = useStart();
	const nav = useNav();

	const login = useMutateLogin();
	const validate = useMutateValidate();
	const signup = useMutateSignup();
	const error = login.error || validate.error || signup.error;
	const disabled = !auth.check || auth.code.length < 6;


	const redirect = (() => {
		const condition = {
			confirm: (!start.user && !auth.email && !auth.phone) || !auth.token,
			update: start.user && !auth.token
		};

		const fn = {
			confirm: () => {
				if (condition.update) nav.go({ to: "/account", replace: true });
				else condition.confirm && nav.go({ to: "/auth", replace: true });
			}
		};
		return fn;
	})();


	return {
		...auth,
		disabled,
		error,
		redirect
	};
};

export const useLogin = () => {
	const auth = useAuth();
	const mutation = useMutateLogin();

	const isLoginPending = useMutationState({
		filters: { mutationKey: ["auth-login"], exact: true },
		select: (mutation) => mutation.state.status === "pending"
	})?.[0];

	return { ...auth, mutation, isLoginPending };
};

export const useValidate = () => {
	const auth = useAuth();

	const loginMutation = useMutateLogin();
	const mutation = useMutateValidate();

	const resend = loginMutation.mutate;

	return { ...auth, mutation, resend };
};

export const useSignup = () => {
	const auth = useAuthValidate();
	const mutation = useMutateSignup();

	return { ...auth, mutation };
};

export const useSecondaryAccount = () => {
	const auth = useAuth();
	const mutation = useMutateSecondary();

	return { ...auth, mutation };
};

export const useLogout = useMutateLogout;